import React from "react";
import { useOutletContext } from "react-router-dom";
import type { ProfileOutletContext } from "../ProfileLayout";

const UsagePage: React.FC = () => {
  const { subscription } = useOutletContext<ProfileOutletContext>();

  const totalUsage = subscription?.usage ?? 0;
  const limit = subscription?.limit ?? 0;
  const planLabel = subscription?.planLabel ?? "Sandbox";
  const remaining = limit ? Math.max(limit - totalUsage, 0) : 0;
  const percentage = limit > 0 ? Math.min((totalUsage / limit) * 100, 100) : 0;

  return (
    <div className="space-y-8">
      <header className="flex flex-col gap-2">
        <div>
          <h2 className="text-2xl font-semibold text-white">Usage</h2>
          <p className="text-sm text-slate-400">
            Monitor your API consumption and plan limits.
          </p>
        </div>
      </header>

      <section className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {/* Plan Card */}
        <div className="rounded-3xl border border-white/10 bg-white/5 p-6 flex flex-col justify-between">
          <div>
            <p className="text-xs uppercase tracking-wide text-slate-400">Current Plan</p>
            <p className="mt-2 text-2xl font-semibold text-white">{planLabel}</p>
          </div>
          <div className="mt-4">
            <span className="inline-flex items-center rounded-full bg-emerald-400/10 px-2 py-1 text-xs font-medium text-emerald-400 ring-1 ring-inset ring-emerald-400/20">
              Active
            </span>
          </div>
        </div>

        {/* Consumption Card */}
        <div className="rounded-3xl border border-white/10 bg-white/5 p-6 relative overflow-hidden">
          <p className="text-xs uppercase tracking-wide text-slate-400">Requests Used</p>
          <div className="mt-3 flex items-baseline gap-2">
            <p className="text-3xl font-semibold text-white">{totalUsage}</p>
            <p className="text-sm text-slate-500">/ {limit}</p>
          </div>

          <div className="mt-4 h-2 w-full rounded-full bg-white/10">
            <div
              className="h-2 rounded-full bg-indigo-500 transition-all duration-500"
              style={{ width: `${percentage}%` }}
            />
          </div>
        </div>

        {/* Remaining Card */}
        <div className="rounded-3xl border border-white/10 bg-white/5 p-6">
          <p className="text-xs uppercase tracking-wide text-slate-400">Remaining</p>
          <p className="mt-3 text-3xl font-semibold text-white">
            {remaining}
          </p>
          <p className="mt-1 text-sm text-slate-400">
            Requests available in this period
          </p>
        </div>

      </section>
    </div>
  );
};

export default UsagePage;
